/* =========================================================================
   Quantity-break up-sell — one click bumps a single-unit line to 3.

   The bulk-ladder-discount Shopify Function reprices qty>=3 automatically,
   so this only changes quantity; it never sets a price. The changed line is
   stamped _af_added_via=qty_break so the orders/paid webhook attributes the
   upgraded line's real revenue.

   Events (placement "qty_break") go to the first-party collector:
     impression = strip rendered in an open drawer (once per line per session)
     add        = upgrade confirmed by Shopify
   ========================================================================= */
(function () {
  'use strict';

  function track(type, el) {
    if (!window.AFUpsell || !el) return;
    window.AFUpsell.track(type, {
      placement: 'qty_break',
      handle: el.getAttribute('data-handle'),
      title: el.getAttribute('data-title'),
      variantId: el.getAttribute('data-variant'),
      price: parseFloat(el.getAttribute('data-price')) || null,
      abVariant: el.getAttribute('data-ab') || null
    });
  }

  /* one impression per line per session, surviving drawer re-renders */
  function seen(key) {
    try {
      var raw = sessionStorage.getItem('af_qtyup_seen') || '';
      if (raw.indexOf('|' + key + '|') > -1) return true;
      sessionStorage.setItem('af_qtyup_seen', raw + '|' + key + '|');
      return false;
    } catch (e) { return false; }
  }

  function trackImpressions() {
    document.querySelectorAll('[data-af-qty-upgrade]').forEach(function (el) {
      var key = el.getAttribute('data-key');
      if (key && !seen(key)) track('impression', el);
    });
  }

  /* One /cart/change.js call. Resolves with the parsed cart, rejects with the
     HTTP status and Shopify's message so the caller can tell a stale line, a
     stock shortfall and a network drop apart. change.js REPLACES a line's
     properties wholesale, so callers pass the line's existing ones in `props`. */
  function change(key, qty, props) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        properties: props,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return {}; }).then(function (body) {
        var e = new Error('change ' + r.status);
        e.status = r.status;
        e.description = (body && (body.description || body.message)) || '';
        throw e;
      });
    });
  }

  /* A line's properties as an object. cart-drawer.liquid renders them with
     `item.properties | json`, which emits [name, value] pairs (`[]` when empty);
     /cart.js gives an object (or null). */
  function toProps(src) {
    var p = src, out = {};
    if (typeof p === 'string') {
      try { p = JSON.parse(p || '{}'); } catch (e) { p = {}; }
    }
    if (Array.isArray(p)) {
      p.forEach(function (pair) {
        if (Array.isArray(pair) && pair.length === 2) out[pair[0]] = pair[1];
      });
    } else if (p && typeof p === 'object') {
      Object.keys(p).forEach(function (k) { out[k] = p[k]; });
    }
    return out;
  }

  function withTag(props) {
    props._af_added_via = 'qty_break';
    return props;
  }

  /* Short stock is a different failure from a stale key: Shopify answers 422
     "Only N items were added to your cart due to availability." and it is NOT a
     no-op — the line is capped at N, re-keyed, and carries the properties we
     sent, qty_break tag included. Retrying asks for the same impossible number. */
  function isShortStock(err) {
    return !!err && err.status === 422 && /availab/i.test(err.description || '');
  }

  /* The line key in the strip can be stale: another script (the stepper, a
     cross-sell add, a drawer re-render) may have changed the line since the
     drawer was drawn. Find the same variant in the live cart and use its
     current key (and current properties), once. */
  function retryByVariant(el, qty) {
    var variant = String(el.getAttribute('data-variant'));
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return String(i.variant_id) === variant; })[0];
      if (!line) throw new Error('line gone');
      if (line.quantity >= qty) return { alreadyDone: true };
      return change(line.key, qty, withTag(toProps(line.properties)));
    });
  }

  function swapDrawer(html) {
    var cur = document.getElementById('CartDrawer');
    if (!html || !cur) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    if (!fresh) return false;
    cur.innerHTML = fresh.innerHTML;
    var drawer = document.querySelector('cart-drawer');
    var host = parsed.querySelector('cart-drawer');
    if (drawer && host) drawer.classList.toggle('is-empty', host.classList.contains('is-empty'));
    // #CartDrawer-Overlay sits INSIDE #CartDrawer, so the swap dropped its
    // click-to-close listener; re-attach it as cart-drawer.js does after its swaps.
    var overlay = cur.querySelector('#CartDrawer-Overlay');
    if (overlay && drawer && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    return true;
  }

  /* Header badge + up-sell context, from one /cart.js read. Set directly rather
     than via the cart-update event, whose drawer subscriber re-renders and would
     wipe a message just shown on the line. */
  function syncCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-af-cart-count]').forEach(function (b) {
        b.textContent = c.item_count;
        b.hidden = c.item_count === 0;
      });
      if (window.AFUpsell) window.AFUpsell.setCartContext(c);
    }).catch(function () {});
  }

  /* A message in the line's own error slot (the one Dawn's cart.js uses). */
  function tell(variantId, msg) {
    var input = document.querySelector('#CartDrawer [data-quantity-variant-id="' + variantId + '"]');
    var row = input && input.closest('tr');
    var slot = (row && row.querySelector('.cart-item__error-text')) || document.getElementById('CartDrawer-CartErrors');
    if (slot) slot.textContent = msg;
  }

  /* After a short-stock 422: put the capped line back exactly as the shopper had
     it (starting quantity and original properties, which also drops the qty_break
     tag), repaint from the real cart and say why. */
  function restoreShort(el, qty) {
    var vid = String(el.getAttribute('data-variant'));
    var q0 = parseInt(el.getAttribute('data-q0'), 10) || 1;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var capped = (cart.items || []).filter(function (i) {
        return String(i.variant_id) === vid && i.properties &&
          i.properties._af_added_via === 'qty_break' && i.quantity < qty;
      })[0];
      if (!capped) {
        return refreshDrawer().then(function () {
          tell(vid, 'Not enough left in this option for the ' + qty + '-for price.');
        });
      }
      var left = capped.quantity;
      // Shopify ignores an EMPTY properties object (it never resets a line to no
      // properties), so a line that had none would keep the qty_break tag. Blank the
      // tag explicitly instead; otherwise the original set replaces ours wholesale.
      var orig = toProps(el.getAttribute('data-props'));
      if (!Object.keys(orig).length) orig._af_added_via = '';
      return change(capped.key, q0, orig).then(function (res) {
        if (!swapDrawer(res.sections && res.sections['cart-drawer'])) return refreshDrawer();
      }).then(function () {
        tell(vid, 'Only ' + left + ' left in this option, so the ' + qty + '-for price isn’t available.');
      });
    });
  }

  /* Redraw the drawer when the change response did not carry it, so a
     successful upgrade can never be left showing "Upgrading…". */
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { swapDrawer(s && s['cart-drawer']); })
      .catch(function () {});
  }

  function report(status, reason) {
    /* Failures were silent, which is why "it didn't work one time" could not
       be traced. Send them to GA so the next one says why. */
    if (typeof window.afTrack === 'function') {
      var data = { status: String(status || 'network') };
      if (reason) data.reason = reason;
      try { window.afTrack('qty_break_failed', data); } catch (e) { /* ignore */ }
    }
  }

  function upgrade(el, btn) {
    if (btn.disabled) return;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    var qty = parseInt(el.getAttribute('data-qty'), 10) || 3;
    btn.disabled = true;
    btn.textContent = 'Upgrading…';

    change(el.getAttribute('data-key'), qty, withTag(toProps(el.getAttribute('data-props'))))
      .catch(function (err) {
        var short = isShortStock(err);
        report(err && err.status, short ? 'short_stock' : null);
        err.reported = true;
        if (short) throw err;
        /* 400/404/422 usually mean the key went stale; a network drop is
           worth one more try too. */
        return retryByVariant(el, qty);
      })
      .then(function (res) {
        // Success. Anything past this point is display-only and must not reach the
        // failure branch, which would say "Try again" about an upgrade that landed.
        try {
          track('add', el);
          var drawer = document.querySelector('cart-drawer');
          // `is-empty` lives on the <cart-drawer> HOST, outside the innerHTML
          // swapped below, so it is cleared here. An upgrade always leaves
          // quantity >= 2, so the cart cannot be empty.
          if (drawer) drawer.classList.remove('is-empty');
          // On /cart the page's own form still holds the old quantities, and its
          // Checkout button posts updates[] — which would quietly undo the upgrade.
          // Reload so the page and the drawer both show the real cart.
          if (document.getElementById('main-cart-items')) { window.location.reload(); return; }
          var swapped = res && !res.alreadyDone && swapDrawer(res.sections && res.sections['cart-drawer']);
          if (!swapped) refreshDrawer();
        } catch (e) { refreshDrawer(); }
        syncCart();
      }, function (err) {
        var short = isShortStock(err);
        if (!err || !err.reported) report(err && err.status, short ? 'short_stock' : null);
        if (short) {
          return restoreShort(el, qty).catch(function () { return refreshDrawer(); }).then(syncCart);
        }
        btn.disabled = false;
        btn.textContent = 'Try again';
        setTimeout(function () { if (!btn.disabled) btn.textContent = label; }, 3000);
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.af-qtyup-btn');
    if (!btn) return;
    var el = btn.closest('[data-af-qty-upgrade]');
    if (el) upgrade(el, btn);
  }, true);

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) trackImpressions();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
})();
